// Arabic (العربية), right to left. Keys match en.ts; a key missing here shows the English wording. Wording to be checked by a native speaker
// (see docs/LANGUAGES.md for the words that need a second look).
export const AR: Record<string, string> = {
  "lang.label": "اللغة",
  "auth.brandSub": "إدارة دورة حياة المنتج",
  "auth.wait": "يُرجى الانتظار…",
  "auth.loading": "جارٍ التحميل…",
  "auth.signIn": "تسجيل الدخول",
  "auth.signInSub": "استخدم عنوان البريد الإلكتروني الذي سجّلته لك مؤسستك.",
  "auth.passwordSaved": "تم حفظ كلمة المرور. سجّل الدخول للمتابعة.",
  "auth.sessionEnded": "انتهت جلستك. يُرجى تسجيل الدخول مرة أخرى.",
  "auth.email": "البريد الإلكتروني",
  "auth.password": "كلمة المرور",
  "auth.forgotLink": "هل نسيت كلمة المرور؟",
  "auth.enterEmailPassword": "أدخل بريدك الإلكتروني وكلمة المرور.",
  "auth.twoFactorCheck": "التحقق بخطوتين",
  "auth.recoverySub": "أدخل أحد رموز الاسترداد التي حفظتها عند إعداد التحقق بخطوتين. يعمل كل رمز مرة واحدة فقط.",
  "auth.codeSub": "افتح تطبيق المصادقة وأدخل الرمز المكوّن من 6 أرقام الظاهر لـ Falcon PLM.",
  "auth.recoveryCode": "رمز الاسترداد",
  "auth.sixDigit": "رمز من 6 أرقام",
  "auth.continue": "متابعة",
  "auth.useApp": "استخدم تطبيق المصادقة بدلاً من ذلك",
  "auth.useRecovery": "فقدت هاتفك؟ استخدم رمز استرداد",
  "auth.cancelSignOut": "إلغاء وتسجيل الخروج",
  "auth.recoveryAccepted": "تم قبول رمز الاسترداد. يتبقى لديك {n}؛ أنشئ رموزاً جديدة من «حسابي».",
  "auth.resetTitle": "إعادة تعيين كلمة المرور",
  "auth.resetSub": "أدخل بريدك الإلكتروني وسنرسل لك رابطاً لاختيار كلمة مرور جديدة.",
  "auth.sendReset": "إرسال رابط إعادة التعيين",
  "auth.backToSignIn": "العودة إلى تسجيل الدخول",
  "auth.resetSent": "إذا كان لهذا البريد حساب في Falcon، فإن رابط إعادة التعيين في طريقه إليك. تنتهي صلاحيته خلال ساعة واحدة.",
  "auth.linkUnusable": "لا يمكن استخدام هذا الرابط",
  "auth.requestNewLink": "طلب رابط جديد",
  "auth.welcome": "مرحباً",
  "auth.welcomeName": "مرحباً، {name}",
  "auth.chooseNew": "اختر كلمة مرور جديدة",
  "auth.inviteSub": "اختر كلمة مرور لتفعيل حسابك في Falcon PLM.",
  "auth.resetPasswordSub": "اختر كلمة مرور جديدة لحسابك في Falcon PLM.",
  "auth.otherUser": "هذا المتصفح مسجَّل الدخول باسم {other}. المتابعة تُخرج ذلك الحساب هنا، ليبدأ {email} وحده.",
  "auth.newPassword": "كلمة المرور الجديدة",
  "auth.passwordHint": "10 أحرف على الأقل. الجملة القصيرة سهلة التذكّر وصعبة التخمين.",
  "auth.typeAgain": "اكتبها مرة أخرى",
  "auth.activate": "تفعيل حسابي",
  "auth.saveNewPassword": "حفظ كلمة المرور الجديدة",
  "auth.noMatch": "كلمتا المرور غير متطابقتين.",
  "auth.2fa.title": "إعداد التحقق بخطوتين",
  "auth.2fa.required": "التحقق بخطوتين مطلوب لك (بصفتك مسؤولاً، أو لأن مؤسستك تطلبه من الجميع). وهو يمنع من يعرف كلمة مرورك من الدخول.",
  "auth.2fa.step1": "{b}ثبّت تطبيق مصادقة{eb} على هاتفك، مثل Google Authenticator أو Microsoft Authenticator (مجاني).",
  "auth.2fa.step2": "{b}امسح هذا الرمز{eb} بالتطبيق (اضغط + ثم «مسح رمز QR»).",
  "auth.2fa.qrAlt": "رمز QR لتطبيق المصادقة",
  "auth.2fa.cantScan": "لا يمكنك المسح؟ أدخل هذا المفتاح في التطبيق بدلاً من ذلك:",
  "auth.2fa.step3": "{b}أدخل الرمز المكوّن من 6 أرقام{eb} الذي يظهره التطبيق الآن لـ Falcon PLM.",
  "auth.2fa.turnOn": "تشغيل التحقق بخطوتين",
  "auth.2fa.on": "تم تشغيل التحقق بخطوتين.",
  "auth.2fa.saveCodes": "{b}احفظ رموز الاسترداد هذه الآن.{eb} إذا فقدت هاتفك، يتيح لك كل رمز تسجيل الدخول مرة واحدة. احتفظ بها في مكان آمن، مثل مدير كلمات المرور أو نسخة مطبوعة في مكان مغلق. لن تُعرض مرة أخرى.",
  "auth.2fa.copy": "نسخ الرموز",
  "auth.2fa.download": "تنزيل كملف نصي",
  "auth.2fa.saved": "لقد حفظتها · متابعة",
  "auth.err.BAD_LOGIN": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
  "auth.err.LOCKED": "محاولات خاطئة كثيرة. حاول لاحقاً، أو أعد تعيين كلمة المرور.",
  "auth.err.BAD_CODE": "الرمز غير صحيح. تحقق من الوقت على هاتفك وجرّب أحدث رمز.",
  "auth.err.LINK_EXPIRED": "انتهت صلاحية هذا الرابط أو تم استخدامه من قبل. اطلب رابطاً جديداً.",
  "auth.err.NOT_SIGNED_IN": "انتهت صلاحية تسجيل دخولك. يُرجى تسجيل الدخول مرة أخرى.",
  "auth.err.MFA_REQUIRED": "أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة.",
  "qch.ready": "جاهز لفحص الجودة",
  "qch.readySub": "أوامر الشراء التي أصبح إنتاجها بالجملة جاهزاً للفحص.",
  "qch.draftSaved": "تم حفظ المسودة",
  "qch.inProgress": "قيد التنفيذ",
  "qch.colour": "اللون",
  "qch.productType": "نوع المنتج",
  "qch.quantity": "الكمية",
  "qch.inspection": "الفحص",
  "qch.inspecting": "يقوم {name} بفحص هذا البند.",
  "qch.another": "مفتش آخر",
  "qch.continue": "متابعة الفحص",
  "qch.start": "بدء الفحص",
  "qch.actionNeeded": "مطلوب إجراء",
  "qch.replies": "{n} ردود",
  "qch.openAnswer": "افتح {report} وأجب",
  "qch.actionFromYou": "مطلوب منك إجراء",
  "qch.nothingReady": "لا يوجد شيء جاهز لفحص الجودة حالياً. تظهر البنود هنا بمجرد بدء إنتاجها بالجملة.",
  "qch.newOnReports": "جديد في تقاريرك",
  "qch.mine": "فحوصاتي",
  "qch.stepByStep": "الفحوصات خطوة بخطوة",
  "qch.mineSub": "المسودات والتقارير المرسلة.",
  "qch.noInspections": "لا توجد فحوصات بعد. ابدأ فحصاً من «جاهز لفحص الجودة».",
  "qch.round1": "فحص الجودة الأول",
  "qch.round2": "فحص الجودة الثاني",
  "qch.roundN": "فحص الجودة {n}",
  "pw.garment": "الملابس",
  "pw.footwear": "الأحذية",
  "pw.product": "المنتج",
  "pw.general": "عام",
  "pw.measuredGarments": "قطع الملابس المقاسة",
  "pw.measuredPairs": "الأزواج المقاسة",
  "pw.measuredPieces": "القطع المقاسة",
  "pw.trims": "الإكسسوارات والطباعة",
  "pw.components": "المكونات",
  "pw.pcs": "قطعة",
  "pw.pairs": "زوج",
  "pw.piecesWord": "قطعة",
  "pw.pairsWord": "زوج",
  "step.inspection": "الفحص",
  "step.checks": "الصور والفحوصات",
  "step.workmanship": "جودة التصنيع",
  "step.measurements": "القياسات",
  "step.result": "النتيجة",
  "sec.packing": "التعبئة والتغليف",
  "sec.labels": "الملصقات والبطاقات",
  "sec.other": "فحوصات أخرى",
  "sec.video": "فيديو",
  "sev.none": "لا يوجد عيب",
  "sev.minor": "بسيط",
  "sev.major": "رئيسي",
  "sev.critical": "حرج",
  "lvl.I": "المستوى العام I",
  "lvl.II": "المستوى العام II",
  "lvl.III": "المستوى العام III",
  "lvl.S-1": "خاص S-1",
  "lvl.S-2": "خاص S-2",
  "lvl.S-3": "خاص S-3",
  "lvl.S-4": "خاص S-4",
  "lvl.100%": "100% (كل قطعة)",
  "msg.photo": "أضف صورة واحدة على الأقل",
  "msg.answer": "أجب بنعم أو لا",
  "msg.reason": "اذكر ما هو الخطأ",
  "msg.required": "هذا مطلوب",
  "msg.checkedOver": "لا يمكن أن تتجاوز الكمية الجاهزة",
  "msg.point": "أكمل نقطة القياس والمقاس والقياس الفعلي",
  "msg.addedPhoto": "أضف صورة أو احذف هذا الفحص",
  "msg.title": "أدخل عنواناً",
  "chk:Garment front": "الوجه الأمامي للقطعة",
  "chk:Garment back": "الوجه الخلفي للقطعة",
  "chk:Inside and seams": "الداخل والدرزات",
  "chk:Carton and carton marks": "الكرتونة وعلامات الكرتونة",
  "chk:Carton label": "ملصق الكرتونة",
  "chk:Polybag": "الكيس البلاستيكي",
  "chk:Polybag sticker": "ملصق الكيس البلاستيكي",
  "chk:Folding": "الطيّ",
  "chk:Swing tag": "بطاقة التعليق",
  "chk:Wash care label": "ملصق تعليمات الغسيل",
  "chk:Brand label": "ملصق العلامة التجارية",
  "chk:Size label": "ملصق المقاس",
  "chk:Pair side view": "منظر جانبي للزوج",
  "chk:Top view": "منظر علوي",
  "chk:Sole": "النعل",
  "chk:Inside and insole": "الداخل والنعل الداخلي",
  "chk:Toe cap and heel": "مقدمة الحذاء والكعب",
  "chk:Shoe box": "علبة الحذاء",
  "chk:Tissue and stuffing": "ورق التغليف والحشو",
  "chk:Box label": "ملصق العلبة",
  "chk:Front": "الوجه الأمامي",
  "chk:Back": "الوجه الخلفي",
  "chk:Inside or detail": "الداخل أو التفاصيل",
  "chk:Inner packing": "التعبئة الداخلية",
  "chk:Product label": "ملصق المنتج",
  "qcw.title": "فحص الجودة",
  "qcw.steps": "الخطوات",
  "qcw.stepOf": "الخطوة {n} من {total}",
  "qcw.moreActions": "إجراءات أخرى",
  "qcw.close": "إغلاق",
  "qcw.removeDraft": "حذف المسودة",
  "qcw.back": "رجوع",
  "qcw.next": "التالي",
  "qcw.submit": "إرسال التقرير",
  "qcw.nOf": "{n} من {total}",
  "qcw.alertOne": "يجب إكمال خانة واحدة قبل المتابعة",
  "qcw.alertMany": "يجب إكمال {n} خانات قبل المتابعة",
  "qcw.everyPiece": "كل قطعة (الدفعة أصغر من العينة)",
  "qcw.everyPair": "كل زوج (الدفعة أصغر من العينة)",
  "qcw.codeLetter": "حرف الرمز {letter}",
  "qcw.enterFinished": "أدخل الكمية الجاهزة",
  "qcw.belowNote": "أقل من العينة المطلوبة وفق المعيار ({n} من {total})",
  "qcw.overOrder": "أكثر من كمية الطلب ({n} {unit}). تحقّق من الرقم.",
  "qcw.sizeTotal": "المجموع {n} من {total} {unit}",
  "qcw.sizeNoteChecked": "مجموع المقاسات المفحوصة {n}، وليس الكمية المفحوصة البالغة {total}. يمكنك المتابعة.",
  "qcw.sizeNoteSample": "مجموع المقاسات المفحوصة {n}، وليس حجم العينة البالغ {total}. يمكنك المتابعة.",
  "qcw.tagWarn": "عدد الصور الموسومة بـ {list} أكبر من الرقم المُدخل. تحقّق من الأعداد.",
  "qcw.shouldBe": "يجب أن يكون {spec}، التفاوت المسموح {tol}",
  "qcw.tolNotGiven": "غير محدد",
  "qcw.choosePoint": "اختر نقطة القياس والمقاس",
  "qcw.diffWithin": "الفرق {diff} · ضمن التفاوت المسموح",
  "qcw.diffOutside": "الفرق {diff} · خارج التفاوت المسموح بمقدار {beyond}",
  "qcw.standard": "ISO 2859-1 (ANSI/ASQ Z1.4)، فحص عادي، أخذ عينات مفرد · {level} · AQL حرج {c}، رئيسي {m}، بسيط {n}",
  "qcw.po": "أمر الشراء",
  "qcw.style": "الموديل",
  "qcw.orderQty": "كمية الطلب",
  "qcw.techpack": "ملف المواصفات الفنية",
  "qcw.newerRev": "توجد نسخة أحدث (النسخة {n})",
  "qcw.noTechpack": "لم يُصدر ملف مواصفات فنية مع أمر الشراء هذا.",
  "qcw.noTechpackShort": "لم يُصدر ملف مواصفات فنية مع أمر الشراء هذا",
  "qcw.sealPhotos": "صور {name}",
  "qcw.noPhotos": "لا توجد صور.",
  "qcw.finishedQty": "الكمية الجاهزة المتاحة للفحص ({unit})",
  "qcw.packedReady": "المعبأة والجاهزة فقط من أمر الشراء هذا ({unitWord})",
  "qcw.checkedQty": "الكمية المفحوصة ({unit})",
  "qcw.piecesChecked": "القطع التي فحصتها فعلاً",
  "qcw.pairsChecked": "الأزواج التي فحصتها فعلاً",
  "qcw.sampleRequired": "العينة المطلوبة وفق المعيار",
  "qcw.viewTable": "عرض الجدول",
  "qcw.reasonOptional": "السبب (اختياري)",
  "qcw.reason": "السبب",
  "qcw.sizesChecked": "المقاسات المفحوصة (اختياري)",
  "qcw.piecesInSize": "القطع المفحوصة من المقاس {size}",
  "qcw.noSizes": "لا توجد مقاسات في بند أمر الشراء هذا.",
  "qcw.refCaption": "من ملف المواصفات الفنية، النسخة {rev}، الصادر مع {po}",
  "qcw.noRef": "لا يوجد مرجع في ملف المواصفات الفنية",
  "qcw.refFor": "مرجع {name}",
  "qcw.severity": "الخطورة",
  "qcw.photo": "صورة",
  "qcw.photoWaiting": "صورة بانتظار الرفع",
  "qcw.noteOptional": "ملاحظة (اختياري)",
  "qcw.photoNote": "ملاحظة الصورة",
  "qcw.removePhoto": "حذف الصورة",
  "qcw.waitingUpload": "بانتظار الرفع…",
  "qcw.optional": "(اختياري)",
  "qcw.showRef": "عرض المرجع من ملف المواصفات الفنية",
  "qcw.refTitle": "المرجع من ملف المواصفات الفنية",
  "qcw.matches": "مطابق لملف المواصفات الفنية؟",
  "qcw.yes": "نعم",
  "qcw.no": "لا",
  "qcw.whatWrong": "ما هو الخطأ؟",
  "qcw.defectsFound": "العيوب الموجودة في {n} {unit} المفحوصة",
  "qcw.noSpec": "لا يوجد جدول مقاسات في ملف المواصفات الفنية",
  "qcw.pomUnit": "نقطة القياس ({unit})",
  "qcw.tolerance": "التفاوت المسموح",
  "qcw.size": "المقاس",
  "qcw.point": "نقطة القياس",
  "qcw.requiredSize": "القياس المطلوب",
  "qcw.toleranceOptional": "التفاوت المسموح (اختياري)",
  "qcw.measuredSize": "القياس الفعلي",
  "qcw.pieceNo": "رقم القطعة",
  "qcw.pieceNoOptional": "رقم القطعة (اختياري)",
  "qcw.remove": "حذف",
  "qcw.allWithin": "هل كلها ضمن التفاوت المسموح؟",
  "qcw.sizeSpec": "جدول المقاسات",
  "qcw.pointsOut": "النقاط خارج التفاوت المسموح",
  "qcw.noSpecType": "لا يوجد جدول مقاسات في ملف المواصفات الفنية: اكتب نقطة القياس والقياس المطلوب والقياس الفعلي.",
  "qcw.addPoint": "إضافة نقطة أخرى",
  "qcw.pointNotInSpec": "نقطة غير موجودة في جدول المقاسات",
  "qcw.aqlHead": "تم فحص {n} {unit} · يتطلب المعيار {total} {unit} · AQL {c} / {m} / {x}",
  "qcw.pass": "مقبول",
  "qcw.fail": "مرفوض",
  "qcw.incomplete": "غير مكتمل",
  "qcw.sampleBelow": "العينة أقل من المعيار: تم فحص {n} {unit}، ويتطلب المعيار {total} {unit}",
  "qcw.sampleMet": "العينة تفي بالمعيار",
  "qcw.found": "الموجود",
  "qcw.allowed": "المسموح",
  "qcw.ok": "مقبول",
  "qcw.over": "تجاوز",
  "qcw.includesMeasurements": "يشمل {n} من القياسات",
  "qcw.takePhoto": "التقاط صورة",
  "qcw.chooseGallery": "اختيار من المعرض",
  "qcw.uploadComputer": "رفع من الكمبيوتر",
  "qcw.addPhotos": "إضافة صور",
  "qcw.srcCamera": "الكاميرا",
  "qcw.srcUpload": "مرفوع من الكمبيوتر",
  "qcw.srcGallery": "المعرض",
  "qcw.srcGalleryTaken": "المعرض · التُقطت {date}",
  "qcw.takenBefore": "التُقطت قبل بدء هذا الفحص",
  "qcw.beforeStarted": "قبل بدء الفحص",
  "qcw.checksHelp": "افتح قسماً، والتقط الصور، وأجب عن كل فحص. يُفتح قسم واحد فقط في كل مرة.",
  "qcw.trimsFrom": "من ملف المواصفات الفنية، النسخة {rev} · {n} إكسسوارات",
  "qcw.trimsFromOne": "من ملف المواصفات الفنية، النسخة {rev} · {n} إكسسوار",
  "qcw.otherIntro": "لكل ما لا ينتمي إلى الأقسام أعلاه.",
  "qcw.nothingToCheck": "لا يوجد ما يُفحص",
  "qcw.addCheck": "إضافة فحص آخر",
  "qcw.addCheckTo": "إضافة فحص آخر إلى {title}",
  "qcw.checkTitle": "عنوان الفحص",
  "qcw.titlePh": "العنوان",
  "qcw.addedByInspector": "أضافه المفتش",
  "qcw.removeCheck": "حذف هذا الفحص",
  "qcw.isOk": "هل هو سليم؟",
  "qcw.notesOptional": "ملاحظات (اختياري)",
  "qcw.recordVideo": "تسجيل فيديو",
  "qcw.uploadVideo": "رفع فيديو",
  "qcw.overallVideo": "فيديو عام",
  "qcw.videoPreparing": "قيد التجهيز (720p)…",
  "qcw.replacesVideo": "{label} (يستبدل الفيديو)",
  "qcw.videoMax": "دقيقتان تقريباً كحد أقصى.",
  "qcw.addedCheck": "فحص مُضاف",
  "qcw.piece": "القطعة",
  "qcw.shouldMeasured": "يجب أن يكون {spec}، والقياس الفعلي {measured}",
  "qcw.noPointsOut": "لا توجد نقاط خارج التفاوت المسموح.",
  "qcw.answeredNo": "الإجابة «لا»",
  "qcw.commentsOptional": "تعليقات (اختياري)",
  "qcw.waitingConnection": "بانتظار الاتصال",
  "qcw.saving": "جارٍ الحفظ…",
  "qcw.saved": "تم الحفظ",
  "qcw.notPicture": "هذا الملف ليس صورة.",
  "qcw.videoTooLong": "الفيديو أطول من دقيقتين تقريباً. سجّل فيديو أقصر.",
  "qcw.uploading": "جارٍ الرفع {n}%",
  "qcw.videoFailed": "تعذّر رفع الفيديو.",
  "qcw.videoUploaded": "تم رفع الفيديو. وهو قيد التجهيز (720p).",
  "qcw.removeVideoQ": "حذف الفيديو؟",
  "qcw.titleLabel": "العنوان",
  "qcw.addCheckNote": "يُضاف الفحص إلى {section} مع علامة «أضافه المفتش». يحتاج إلى صورة واحدة على الأقل وإجابة بنعم أو لا.",
  "qcw.cancel": "إلغاء",
  "qcw.addCheckBtn": "إضافة الفحص",
  "qcw.enterTitle": "أدخل عنواناً.",
  "qcw.removeCheckQOne": "حذف الفحص «{title}» و{n} صورة له؟",
  "qcw.removeCheckQ": "حذف الفحص «{title}» وصوره البالغ عددها {n}؟",
  "qcw.removePhotoQ": "حذف هذه الصورة؟",
  "qcw.removeDraftQ": "حذف هذه المسودة؟ ستُحذف صورها وإجاباتها.",
  "qcw.draftRemoved": "تم حذف المسودة.",
  "qcw.stepIncomplete": "خطوة «{step}» غير مكتملة بعد.",
  "qcw.photosWaiting": "ما زالت بعض الصور بانتظار الرفع. انتظر حتى تظهر «تم الحفظ».",
  "qcw.submitQ": "إرسال التقرير؟ بعد ذلك يُقفل ولا يمكنك سوى إضافة تفاصيل.",
  "qcw.submitted": "تم إرسال التقرير.",
  "qcw.writeEnglish": "(اكتب باللغة الإنجليزية)",
  "qcw.writeEnglishShort": "اكتب باللغة الإنجليزية",
  "qcw.err.QC_INCOMPLETE": "التقرير غير مكتمل بعد. تم فتح أول خطوة بها نقص.",
  "guide.button": "دليل العيوب",
  "guide.title": "دليل تصنيف العيوب",
  "guide.reminder": "للتذكير فقط — هذا الدليل لا يُضمَّن في تقرير الفحص المحفوظ أو ملف PDF.",
  "guide.close": "إغلاق",
  "guide.nounGarment": "القطعة",
  "guide.nounFootwear": "الحذاء",
  "guide.nounProduct": "المنتج",
  "guide.NounGarment": "القطعة",
  "guide.NounFootwear": "الحذاء",
  "guide.NounProduct": "المنتج",
  "guide.criticalWhat": "خطر على السلامة / الامتثال",
  "guide.criticalNote": "عادةً يعني عيب حرج واحد أن الفحص يجب أن يُرفض.",
  "guide.c1": "خامة مقاومة للهب / غير مقاومة للهب غير صحيحة",
  "guide.c2": "جسم حاد خطير متروك في {item}",
  "guide.c3": "مكوّن حماية مطلوب مفقود",
  "guide.c4": "منتج موسوم خطأً بأنه يستوفي معيار سلامة",
  "guide.c5": "أي شيء يسبب مشكلة فورية في السلامة أو الامتثال",
  "guide.majorWhat": "الوظيفة / رفض العميل",
  "guide.majorNote": "عيب خطير يؤثر على الاستخدام أو الأداء أو المواصفات المتوقعة.",
  "guide.m1": "سحّاب مكسور",
  "guide.m2": "تمزق كبير في الدرزة",
  "guide.m3": "شريط عاكس مفقود",
  "guide.m4": "ملصق خاطئ أو لون خاطئ",
  "guide.m5": "قياس خارج التفاوت المسموح بشكل كبير",
  "guide.m6": "الشعار / الطباعة في موضع سيئ",
  "guide.m7": "{Item} غير صالح للاستخدام المقصود",
  "guide.minorWhat": "مشكلة شكلية / تصنيع بسيطة",
  "guide.minorNote": "مشكلة صغيرة لا تؤثر جوهرياً على السلامة أو الوظيفة العادية.",
  "guide.n1": "خيط سائب",
  "guide.n2": "عدم انتظام بسيط في الغرز",
  "guide.n3": "علامة شكلية صغيرة",
  "guide.n4": "مشكلة بسيطة في موضع الملصق",
  "guide.priority": "عندما تحدد مواصفات العميل أو ملف المواصفات الفنية المعتمد أو متطلبات معدات الوقاية الشخصية أو معيار مطبَّق التصنيفَ، تكون لها الأولوية.",
  "std.title": "معيار الجودة: العينة والعيوب المسموحة",
  "std.fewer": "إذا فُحصت قطع أقل من المطلوب، فإن العيوب المسموحة تتبع الكمية المفحوصة فعلاً.",
  "std.all": "100%: تُفحص كل قطعة جاهزة ولا يُسمح بأي عيوب.",
  "std.finished": "الكمية الجاهزة (قطعة)",
  "std.sample": "العينة المطلوبة",
  "std.critical": "الحرجة المسموحة",
  "std.major": "الرئيسية المسموحة",
  "std.minor": "البسيطة المسموحة",
  "std.andMore": " فأكثر",
  "std.orAll": " أو الكل إذا كانت أقل",
  // ---- Legal documents: the agreement screen and the footer links (the documents themselves stay English) -------------
  "legal.title": "قبل المتابعة",
  "legal.intro": "يُرجى قراءة المستندات أدناه والموافقة عليها لاستخدام Falcon PLM في {org}.",
  "legal.updated": "تم تحديث المستندات القانونية (الإصدار {version}). يُرجى قراءتها والموافقة عليها مرة أخرى للمتابعة.",
  "legal.terms": "شروط الخدمة",
  "legal.privacy": "سياسة الخصوصية",
  "legal.dpa": "اتفاقية معالجة البيانات",
  "legal.subprocessors": "المعالجون الفرعيون",
  "legal.agreeTerms": "أوافق على {terms} وقد قرأت {privacy}",
  "legal.agreeDpa": "أقبل {dpa} نيابةً عن {org}",
  "legal.dpaNote": "بصفتك المسؤول الرئيسي، فإنك تقبل أيضًا اتفاقية معالجة البيانات نيابةً عن مؤسستك.",
  "legal.englishDocs": "تُفتح المستندات في علامة تبويب جديدة، وهي باللغة الإنجليزية.",
  "legal.continue": "موافقة ومتابعة",
  "legal.tickTerms": "ضع علامة في المربع للموافقة قبل المتابعة.",
  "legal.tickDpa": "ضع علامة في المربع لقبول اتفاقية معالجة البيانات قبل المتابعة.",
  "legal.version": "الإصدار {version}",
  "legal.englishNote": "هذا المستند باللغة الإنجليزية. إذا كان هناك أي شيء غير واضح، يُرجى سؤال المسؤول في مؤسستك.",
  "legal.footTerms": "الشروط",
  "legal.footPrivacy": "الخصوصية",
  "legal.footDpa": "معالجة البيانات",
  "legal.footSub": "المعالجون الفرعيون",
};
